import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfigProblem } from './firebaseConfig';

const siteConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const dataConfig = {
  apiKey: process.env.REACT_APP_DATA_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_DATA_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_DATA_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_DATA_FIREBASE_APP_ID,
};

const configError = firebaseConfigProblem({ site: siteConfig, data: dataConfig });

if (configError) console.error(`[firebase] ${configError}`);

const app = configError ? null : initializeApp(siteConfig);
// Auth and Analytics stay on the site app only, so the data app never carries credentials.
const dataApp = configError ? null : initializeApp(dataConfig, 'data');

const signupDb = app ? getFirestore(app) : null;
const dataDb = dataApp ? getFirestore(dataApp) : null;

let analytics = null;
try {
  if (app && typeof window !== 'undefined' && siteConfig.measurementId) {
    analytics = getAnalytics(app);
  }
} catch (err) {
  console.warn('[firebase] Analytics unavailable:', err.message);
}

let auth = null;
const getAppAuth = () => {
  if (!app) return null;
  if (!auth) auth = getAuth(app);
  return auth;
};

export { app, analytics, dataDb, signupDb, configError as firebaseConfigError, getAppAuth };
